// The sentence under a refund's account picker. Kept pure so its wording, which
// is the only thing telling the bookkeeper how much to trust the suggestion, has a
// test of its own.

import type { RefundSuggestion } from './types';

const money = (n: number) => `$${Math.abs(n).toFixed(2)}`;

/**
 * "Looks like the return of QRX TOOLS $85.00 on Jun 1" when the amount agrees;
 * "Same merchant as QRX TOOLS $12.00 on Jun 3, different amount" when only the
 * merchant does. The second wording is the point: a same-merchant guess is useful
 * and must not read as a fact.
 */
export function refundSuggestionCaption(s: RefundSuggestion, formatDate: (iso: string) => string): string {
  const who = (s.description || 'a purchase').trim();
  const when = formatDate(s.txn_date);
  return s.amount_matches
    ? `Looks like the return of ${who} ${money(s.amount)} on ${when}`
    : `Same merchant as ${who} ${money(s.amount)} on ${when}, different amount`;
}

/** True when the refund already carries the suggested account, so the offer is moot. */
export const suggestionAdopted = (s: RefundSuggestion | null | undefined, categoryId: number | null | undefined): boolean =>
  !!s && categoryId != null && Number(categoryId) === Number(s.category_id);
